import axios from "axios";

const CMS_SERVER = import.meta.env.VITE_METADATA_SERVER;
const METADATA_API = import.meta.env.VITE_METADATA_API_SERVER;

const apiInstance = axios.create({})

const getFeatureTypeMetadata = async (featureTypeGuid) => {
    try {
        const url = METADATA_API + "/featureType/" + featureTypeGuid
        const response = await apiInstance.get(url)

        return response?.data
    } catch (err) {
        return null;
    }
}

const getFrequentlyAskedQuestions = async () => {
    try {
        const url = METADATA_API + "/frequentlyAskedQuestions"
        const response = await apiInstance.get(url)

        return response?.data
    } catch (err) {
        return null;
    }
}

const getBanksInfo = async () => {
    try {
        const url = `${CMS_SERVER}/api/banks`;

        const response = await apiInstance.get(url, {
            params: {
                'fields[0]': 'name',
                'fields[1]': 'label',
                'fields[2]': 'link',
                'populate[logo][fields][0]': 'url',
            }
        });

        const banks = response?.data?.data ?? [];

        return banks.map((bank) => {
            const attributes = bank?.attributes ?? {};
            const logoUrl = attributes?.logo?.data?.attributes?.url;

            return {
                name: attributes?.name ?? '',
                label: attributes?.label ?? '',
                link: attributes?.link ?? '',
                logo: logoUrl ? `${CMS_SERVER}${logoUrl}` : null,
            };
        });
    } catch (err) {
        return [];
    }
};

const getManufacturerLogoUrl = async (manufacturerId) => {
    try {
        const url = `${CMS_SERVER}/api/manufacturers`;

        const response = await apiInstance.get(url, {
            params: {
                'filters[manufacturer_id][$eq]': manufacturerId,
                'fields[0]': 'manufacturer_id',
                'fields[1]': 'label',
                'populate[logo][fields][0]': 'url',
            }
        });

        const manufacturer = response?.data?.data?.[0];
        if (!manufacturer) {
            return null;
        }

        const logoUrl = manufacturer?.attributes?.logo?.data?.attributes?.url;
        if (!logoUrl) {
            return null;
        }

        return `${CMS_SERVER}${logoUrl}`;
    } catch (err) {
        return null;
    }
};

export { getBanksInfo, getFeatureTypeMetadata, getFrequentlyAskedQuestions, getManufacturerLogoUrl };
